
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"56","height":"56"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M50.586 22.735a5.429 5.429 0 00-1.186.132l-7.262-10.35a5.419 5.419 0 10-9.6-4.759h-9.122a5.418 5.418 0 10-9.8 4.455L6.473 22.837A5.415 5.415 0 106.3 33.489l7.413 10.443a5.406 5.406 0 109.415 5.273h9.7a5.408 5.408 0 109.631-4.916l6.766-10.9a5.413 5.413 0 101.364-10.652zm-5.028 3.416H31.319l5.881-11.33c.163.015.328.021.5.021a5.434 5.434 0 001.1-.112l7.3 10.408a6.267 6.267 0 00-.542 1.013zM33.624 13.015L28 23.846 22.353 12.99a5.515 5.515 0 00.773-1.154h9.7a5.8 5.8 0 00.798 1.179zM18.257 14.84c.181 0 .36-.005.536-.022l5.881 11.333H10.442a4.986 4.986 0 00-.606-1.119l6.982-10.384a5.416 5.416 0 001.439.192zm-7.815 15.306h14.274l-5.882 11.337a5.48 5.48 0 00-.577-.029 5.422 5.422 0 00-1.275.153L9.738 31.4a4.564 4.564 0 00.704-1.254zM22.38 43.355L28 32.539l5.6 10.783a5.746 5.746 0 00-1.063 1.888h-9.121a5.612 5.612 0 00-1.036-1.855zm15.313-1.9c-.181 0-.36.005-.536.022l-5.88-11.331h14.281a4.155 4.155 0 00.426.848l-6.648 10.715a5.406 5.406 0 00-1.643-.252z","fill":"#222"}})])
          )
        }
      }
    